export const CounterTestPageObject = (count: string | number) => ({
    getType: () => "Counter",

    getColor: () => "primary",

    getCount: () => count,
});
